<template>
  <section class="flex flex-col gap-4">
    <div class="p-16 bg-surface-primary flex flex-col w-full gap-16">
      <div class="w-full flex flex-col gap-8 pb-8">
        <h3
          aria-label="Varukorg som innehåller beställning gjort per telefon"
          class="heading-xs mb-16"
        >
          Avtalssammanfattning
        </h3>
        <DownloadSummaryLinkBox
          :link="`/shop/avtalssammanfattning/${orderGuid ? props.orderGuid : 'varukorg'}`"
          :generate-on-mount="props.generateOnMount"
        />
      </div>
      <div
        class="w-full flex flex-col gap-8 pt-16 border-t-md border-solid border-border-secondary"
      >
        <p>
          När jag trycker på "Slutför köp" godkänner jag Halebops
          <NuxtLink>villkor</NuxtLink> pch bekräftar att jag tagit del av
          avtalssammanfattningen samt att en kreditprövning kan göras i samband
          med beställningen.
        </p>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
import DownloadSummaryLinkBox from './order/complete/DownloadSummaryLinkBox.vue';

const props = defineProps<{ orderGuid?: string; generateOnMount: boolean }>();
</script>
